import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../index.css';
import LandingPage from './LandingPage';

// Primes the csrftoken cookie — previously a side effect of Django's
// home_view serving this HTML shell, which no longer happens once GCS/CDN
// serves it directly.
fetch('/api/public/csrf/', { credentials: 'include' }).catch(() => {});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>,
);
